import {Button, Checkbox, Dialog, DialogActions, DialogContent, Tab, Tabs} from "@mui/material";
import Mesailer from "../gunsonu/Mesailer";
import Etkinlikler from "./Etkinlikler";
import logbookApi from "../../../api/staffApi/logbookApi";
import dayjs from "dayjs";
import * as React from "react";
import {IEtkinlik, IKalem, IKisi, IMesaiKayit} from "../../../constants/types/logbook";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {DatePicker} from "@mui/x-date-pickers";
import CustomTabPanel from "../../../components/CustomTabPanel";
import hasPermission from "../../../redux/hasPermission";

const GunSecimiDialog = (
    {
        onClose,
        takvimVerileriGetir,
        seciliTarih,
        seciliTarihCalisanlar,
        setSeciliTarihCalisanlar,
        seciliTarihEtkinlikler,
        setSeciliTarihEtkinlikler,
        kisiler
    }: {
        onClose: () => void,
        takvimVerileriGetir: () => void,
        seciliTarih: dayjs.Dayjs | null,
        seciliTarihCalisanlar: IKalem<IMesaiKayit>,
        setSeciliTarihCalisanlar: React.Dispatch<React.SetStateAction<IKalem<IMesaiKayit>>>,
        seciliTarihEtkinlikler: IKalem<IEtkinlik>,
        setSeciliTarihEtkinlikler: React.Dispatch<React.SetStateAction<IKalem<IEtkinlik>>>,
        kisiler: IKisi[]
    }) => {
    const [tekrarla, setTekrarla] = React.useState<boolean>(false);
    const [bitisTarih, setBitisTarih] = React.useState<dayjs.Dayjs | null>(null);
    const [activeTab, setActiveTab] = React.useState(0);
    const takvimDuzenleYetki = hasPermission("galleon_logbook.takvimDuzenle");

    const handleSave = () => {
        const {guncellenecekListe, silinecekIdListe, eklenenListe} = seciliTarihCalisanlar;

        // Eğer hiçbir değişiklik yoksa direkt kapat
        if (eklenenListe.length === 0 && silinecekIdListe.length === 0 && Object.keys(guncellenecekListe).length === 0) {
            onClose();
            return;
        }

        // Sadece mesaileri kaydet (Etkinlikler anında kaydediliyor)
        logbookApi.postMesailer({
            tarih: (seciliTarih ?? dayjs()).format("DD-MM-YYYY"),
            tekrarla: tekrarla,
            bitis_tarih: (bitisTarih ?? dayjs()).format("DD-MM-YYYY"),
            calisanlar: tekrarla
                ? [
                    ...seciliTarihCalisanlar.data.filter(q => q.id !== null && !silinecekIdListe.includes(q.id) && !Object.values(guncellenecekListe).map(x => x.id).includes(q.id)),
                    ...Object.values(guncellenecekListe),
                    ...eklenenListe
                ].filter(q => !!q.kisi)
                : {
                    guncellenecekListe: Object.fromEntries(Object.entries(guncellenecekListe).filter(([_, v]) => !!v.kisi)),
                    silinecekIdListe,
                    eklenenListe: eklenenListe.filter(q => !!q.kisi),
                }
        }).then(() => {
            onClose()
            takvimVerileriGetir()
        }).catch(() => {
            console.log("hata")
        });
    };

    return <Dialog
        open={true}
        onClose={onClose}
        fullWidth
        maxWidth="lg"
    >
        <DialogContent>
            <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2
            }}>
                <Tabs value={activeTab} onChange={(_e, val) => setActiveTab(val)}>
                    <Tab label="Mesailer"/>
                    <Tab label="Etkinlikler"/>
                </Tabs>

                <Box
                    sx={{
                        display: "inline-flex",
                        justifyContent: "end",
                        alignItems: "center",
                        verticalAlign: "middle",
                        visibility: activeTab === 0 ? 'visible' : 'hidden'
                    }}
                >
                    {
                        tekrarla && <>
                            <Typography variant="body2" sx={{mr: 1}}>Bitiş Tarihi:</Typography>
                            <DatePicker
                                value={bitisTarih}
                                onChange={(date) => setBitisTarih(dayjs(date))}
                                disablePast
                                minDate={seciliTarih ?? undefined}
                                slotProps={{textField: {size: 'small'}}}
                            />
                        </>
                    }
                    <Typography variant="body2" sx={{ml: 2}}>Tekrarla</Typography>
                    <Checkbox
                        checked={tekrarla}
                        onChange={(e) => setTekrarla(e.target.checked)}
                    />
                </Box>
            </Box>

            <CustomTabPanel value={activeTab} index={0}>
                <Mesailer
                    mesailer={seciliTarihCalisanlar}
                    calisanlar={kisiler}
                    setMesailer={setSeciliTarihCalisanlar}
                />
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={1}>
                <Etkinlikler
                    etkinlikler={seciliTarihEtkinlikler}
                    setEtkinlikler={setSeciliTarihEtkinlikler}
                    canEdit={takvimDuzenleYetki}
                    seciliTarih={seciliTarih}
                    takvimVerileriGetir={takvimVerileriGetir}
                />
            </CustomTabPanel>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={onClose}>
                Vazgeç
            </Button>
            <Button
                variant="contained"
                onClick={handleSave}
            >
                Kaydet
            </Button>
        </DialogActions>
    </Dialog>
}

export default GunSecimiDialog;
